module.exports = __webpack_public_path__ + "static/media/bandaid-beauty-health-svgrepo-com.2142d0af.svg";